import React from 'react';

import { AccountManager, NotificationManager } from '@atlas/core';
import { MenuItemLogout } from '@atlas/ui';

const ClientProfileLogout = () => {
  const onLogOut = () => {
    NotificationManager.display({
      data: { onConfirm: () => AccountManager.logout() },
      message: 'signout_confirm_message',
      title: 'signout_confirm_title',
      type: 'confirm',
    });
  };

  return (
    <MenuItemLogout
      className="menu-item-container menu-item-logout"
      onClick={onLogOut}
      text="logout"
    />
  );
};

export default ClientProfileLogout;
